import {create} from '@wix/fedops-logger';

export interface FedopsLogger {
  appLoaded: () => void;
}

const logger: FedopsLogger = create('marketing-homepage');

export default logger;
